import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "routes";
import "helpers/initFA";
import AppProvider from "providers/AppProvider";
import { env } from "config";
import config from "devextreme/core/config";
import "devextreme/ui/tag_box";

if (env.devextremeKey) {
  config({
    licenseKey: env.devextremeKey,
  });
}

const container = document.getElementById("main");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  </React.StrictMode>
);
